import React from 'react'

const SVG = ({
  style = {},
  fill = "#000",
  width = "100%",
  className = "",
  viewBox = "0 0 86 8"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H87V8H4C1.79086 8 0 6.20914 0 4Z"
      fill={fill}
    />
  </svg>
);

export default SVG;